import { useState, useEffect } from 'react';
import { articlesApi } from '../services/articles';
import { WhatsHotResponse, ArticleList, TreatmentCategory } from '../types/article';

export const useWhatsHot = () => {
  const [data, setData] = useState<WhatsHotResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchWhatsHotData();
  }, []);

  const fetchWhatsHotData = async () => {
    try {
      setLoading(true);
      const response = await articlesApi.getWhatsHot();
      setData(response);
      setError(null);
    } catch (err) {
      console.error("Error fetching What's Hot data:", err);
      setError('Failed to load articles');
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, refetch: fetchWhatsHotData };
};

export const useArticlesByTreatmentCategory = (category: TreatmentCategory | null) => {
  const [articles, setArticles] = useState<ArticleList[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (category) {
      fetchArticles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  const fetchArticles = async () => {
    if (!category) return;

    try {
      setLoading(true);
      const response = await articlesApi.getArticlesByTreatmentCategory(category);
      setArticles(response);
      setError(null);
    } catch (err) {
      console.error('Error fetching articles by category:', err);
      setError('Failed to load articles');
    } finally {
      setLoading(false);
    }
  };

  return { articles, loading, error };
};
